import * as yup from "yup";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const addressFormSchema = yup.object({
  fullName: yup.string().required("Please enter full name!"),
  phone: yup
    .string()
    .required("required")
    .matches(phoneRegExp, "Phone number is not valid")
    .min(10, "Phone number is too short")
    .max(10, "Phone number is too long"),
  postalCode: yup
    .string()
    .required("required")
    .matches(/^[0-9]{6}$/, "Must be exactly 6 digits"),
  street_area_dist: yup.string().required('Street / Area Required'),
  landmark: yup.string(),
  state: yup.string(),
  city: yup.string(),
  country: yup.string(),
  alternatePhone: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .min(10, "Phone number is too short")
    .max(10, "Phone number is too long"),
});
